module.exports = ".eva-editor-wrap {\n  position: relative; }\n  .eva-editor-wrap .eva-editor-save-btn {\n    position: absolute;\n    top: -28px;\n    right: 0;\n    z-index: 1; }\n  .eva-editor-inserts-bar {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -ms-flex-wrap: wrap;\n      flex-wrap: wrap;\n  gap: 4px;\n  margin-bottom: 6px; }\n  .eva-editor-inserts-bar .btn {\n    margin: 0; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/eva-editor/eva-editor.component.scss
// module id = ./src/app/modules/eva-editor/eva-editor.component.scss
// module chunks = main